import { useState, useCallback } from "react";
import { usePlayer } from "@/lib/PlayerContext";
import { usePlayerTimeSync } from "./usePlayerTimeSync";

/**
 * コメントスクロール機能を管理するカスタムフック
 */
export const useCommentScroll = () => {
  const {
    allComments,
    commentScrollEnabled,
    startAt,
    setComments,
    setFilteredComments
  } = usePlayer();
  
  const [playerInstance, setPlayerInstance] = useState<any>(null);
  
  // プレーヤーインスタンスの登録
  const registerPlayer = useCallback((player: any) => {
    setPlayerInstance(player);
  }, []);
  
  // コールバック関数をuseCallbackでメモ化
  const updateComments = useCallback((filtered: any) => {
    setFilteredComments(filtered);
    setComments(filtered);
  }, [setFilteredComments, setComments]);
  
  // 時間同期処理
  usePlayerTimeSync(
    playerInstance,
    allComments,
    startAt,
    commentScrollEnabled,
    updateComments
  );
  
  return { 
    registerPlayer,
    playerInstance,
    commentScrollEnabled,
    allComments: allComments.length
  };
};
